import React from 'react';
import clx from 'classnames';
import './BreadcrumbApp.scss';
import { Breadcrumbs } from 'client/core/router/breadcrumb/Breadcrumbs';

export interface BreadcrumbsContainerProps {
  // TODO verificare utilità isAdmin
  isAdmin?: boolean;
  isAdminPreview?: boolean;
}

/*
 * Contiene il breadcrumb e gli stili per il posizionamento nel Layout
 */
export function BreadcrumbsContainer(props: BreadcrumbsContainerProps) {
  return (
    <div
      className={clx('breadcrumb-container', {
        'is-admin': props.isAdmin
      })}
    >
      <Breadcrumbs />
      {props.isAdminPreview && (
        <div className="top-breadcrumb-lock-in-admin-preview"></div>
      )}
    </div>
  );
}
